// --------------------------------------------------------------
// Created On: 2021-12-14
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { configureStore } from "@reduxjs/toolkit";
import currentUserReducer from "./features/currentUserSlice";
import idTokenReducer from "./features/idTokenSlice";
import accessTokenReducer from "./features/accessTokenSlice";
import refreshTokenReducer from "./features/refreshTokenSlice";
import sessionTokenReducer from "./features/sessionTokenSlice";
import cartQuantityReducer from "./features/cartQuantitySlice";

export const store = configureStore({
  reducer: {
    currentUser: currentUserReducer,
    idToken: idTokenReducer,
    accessToken: accessTokenReducer,
    refreshToken: refreshTokenReducer,
    sessionToken: sessionTokenReducer,
    cartQuantity: cartQuantityReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type ReduxDispatch = typeof store.dispatch;
